import { ListAtsJobsQuery } from 'generated-graphql/hooks/apollo-hooks';
import { extractListItems } from 'core/utils/apollo/extractListItems';
import { logger } from 'core/utils/logger';

/**
 * Pulls the jobs out of a `listAtsJobs` result, stripping any nulls.
 *
 * `listAtsJobs` is a custom resolver returning `{ jobs, next }` rather than the
 * standard `{ items }` list shape, so the generic `extractQueryListItems`
 * doesn't apply. A missing query/list is logged and yields `[]`.
 */
export const extractAtsJobs = (data: ListAtsJobsQuery | undefined) => {
  const jobs = data?.listAtsJobs?.jobs;
  if (!jobs) {
    logger.error(
      'listAtsJobs returned no jobs. This typically means the query failed or the ATS resolver returned an unexpected shape.'
    );
    return [];
  }

  return extractListItems(jobs);
};
